import { Tag, theme } from '@/components';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';

export const RequiredTag: FC = () => {
  const { t } = useTranslation();
  const { token } = theme.useToken();

  return (
    <Tag
      style={{
        fontSize: 10,
        lineHeight: 1.2,
        borderRadius: 24,
        padding: '2px 8px',
        margin: 0,
        border: `1px solid ${token.colorBorderSecondary}`,
      }}
      color={token.colorPrimary}
    >
      {t('required')}
    </Tag>
  );
};
